import {
  TeacherChatByTypePrivateDocument,
  TeacherChatByTypePrivateQuery,
  TeacherChatByTypePrivateQueryVariables,
  TeacherChatDeleteDocument,
  TeacherChatDeleteMutation,
  TeacherChatDeleteMutationVariables,
  TeacherChatInsertPrivateUserDocument,
  TeacherChatInsertPrivateUserMutation,
  TeacherChatInsertPrivateUserMutationVariables,
  TeacherChatUpdateDocument,
  TeacherChatUpdateMutation,
  TeacherChatUpdateMutationVariables,
} from '../types';
import { client } from '../../client';
import {
  ChatFragment,
  ChatInsertByTypeGroupDocument,
  ChatInsertByTypeGroupMutation,
  ChatInsertByTypeGroupMutationVariables,
} from '../../shared/types';

// teacherPrivateConversationsQuery
export async function teacherGetChatPrivate(variables: TeacherChatByTypePrivateQueryVariables): Promise<TeacherChatByTypePrivateQuery> {
  try {
    const result = await client.query<TeacherChatByTypePrivateQuery, TeacherChatByTypePrivateQueryVariables>({
      query: TeacherChatByTypePrivateDocument,
      fetchPolicy: 'network-only',
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

// teacherPrivateConeversationMutation
export async function teacherCreatePrivateChat(
  variables: TeacherChatInsertPrivateUserMutationVariables,
): Promise<TeacherChatInsertPrivateUserMutation> {
  try {
    const result = await client.mutate<TeacherChatInsertPrivateUserMutation, TeacherChatInsertPrivateUserMutationVariables>({
      mutation: TeacherChatInsertPrivateUserDocument,
      variables,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

export async function teacherCreateChatGroup(variables: ChatInsertByTypeGroupMutationVariables): Promise<ChatFragment> {
  try {
    const result = await client.mutate<ChatInsertByTypeGroupMutation, ChatInsertByTypeGroupMutationVariables>({
      mutation: ChatInsertByTypeGroupDocument,
      variables,
    });
    return result.data.insert_chats_one;
  } catch (error) {
    throw Error(error);
  }
}

// teacherUpdateConeversationMutation
export async function teacherUpdateChat(variables: TeacherChatUpdateMutationVariables): Promise<TeacherChatUpdateMutation> {
  try {
    const result = await client.mutate<TeacherChatUpdateMutation, TeacherChatUpdateMutationVariables>({
      mutation: TeacherChatUpdateDocument,
      variables,
    });
    return result.data;
  } catch (error) {
    throw Error(error);
  }
}

// teacherDeleteConversatiomMutation
export async function teacherDeleteChat(variables: TeacherChatDeleteMutationVariables): Promise<TeacherChatDeleteMutation> {
  try {
    const result = await client.mutate<TeacherChatDeleteMutation, TeacherChatDeleteMutationVariables>({
      mutation: TeacherChatDeleteDocument,
      variables,
    });

    return result.data;
  } catch (error) {
    throw Error(error);
  }
}
